"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Grantee_1 = require("./_Grantee");
exports._TargetGrant = {
    type: "structure",
    required: [],
    members: {
        Grantee: {
            shape: _Grantee_1._Grantee
        },
        Permission: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_TargetGrant.js.map